<template>
  <div class="dashboard-header">
    <a-menu :defaultSelectedKeys="['1']" :defaultOpenKeys="['sub1']" mode="inline" theme="light" :inlineCollapsed="collapsed">
      <a-menu-item key="overview">
        <a-icon type="dashboard" />
        <span>Overview</span>
      </a-menu-item>
      <a-menu-item key="groups">
        <a-icon type="team" />
        <span>Groups</span>
      </a-menu-item>
      <a-menu-item key="discover">
        <a-icon type="search" />
        <span>Discover</span>
      </a-menu-item>
      <a-menu-item key="inbox">
        <a-icon type="mail" />
        <span>Inbox</span>
      </a-menu-item>
    </a-menu>
  </div>
</template>

<script>
export default {
  name: "DashboardHeader",
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
.dashboard-header {
  height: 100%;
}
</style>